import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,

  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    loadAll: async ({ commit }) => {
      commit("setListLoading", true);
      const response = await api.get(`business/all`);
      let businessList = [];
      response.data.forEach(business => {
        let businessData = business;
        if (businessData.services) {
          businessData.services = businessData.services.sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          });
        }
        if (businessData.id == 32) {
          commit("setServices", businessData.services);
        }
        businessList.push({ id: business.id, ...businessData });
      });
      commit("setList", businessList);
      commit("setListLoading", false);
    },
  },
  getters: {
    list: state => {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
};

// eslint-disable-next-line
Array.prototype.unique = function () {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) {
        a.splice(j--, 1);
      }
    }
  }

  return a;
};
